import { CurrencyUahIcon } from './CurrencyUahIcon';

/**
 * author: Michael Irigoyen
 * id F3A1F9C4-307D-40D8-A210-0ECFAC01BDCD
 * name currency-uah
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-uah.svg
 * tags
 * - Banking 
 */
export const CurrencyHryvniaIcon = CurrencyUahIcon;
export default CurrencyHryvniaIcon